import React, { Component } from 'react';
import classnames from 'classnames';
import { countryCodes } from '../helpers/country-codes';


class CountryCodesDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCountryCode: "",
      verifiedPhoneCountry: ""
    };

    this.setCountryCode = this.setCountryCode.bind(this);
  }

  componentDidMount = () => {
    let tempCode;
    if (this.props.country) {
      tempCode = countryCodes.find(x => x['code']?.toString() === this.props.country)
      this.setState({
        selectedCountryCode: tempCode.value
      });
    };
  };

  setCountryCode(event) {
    this.setState({ 
      selectedCountryCode: event.target.value,
    }, () => {
      this.props.onChangeCallback('country', this.state.selectedCountryCode)
    }); 
  }

  render() {
    return (
    	<select 
        name={this.props.name} 
        id={this.props.id} 
        className={classnames('form-control', 'custom-select', 'font-weight-semi-bold', { 'is-invalid': this.props.invalid })}
        value={this.state.selectedCountryCode} 
        onChange={this.setCountryCode}
      >
        {countryCodes.map(country => (
          <option 
            key={country.abbr} 
            value={country.value}
          >
            {country.value}
          </option>
        ))}
			</select>
    );
  }
}

export default CountryCodesDropdown;